import { ExternalLink, Link } from '@/shared/ui/Link'
import { Text } from '@/shared/ui/Typography'

export function OuvidoriaContactInfo() {
  return (
    <>
      <Text size="body3">
        <strong>Horário de Atendimento</strong>
        <br />
        Segunda à Sexta — 09h00 às 17h00
        <br />
        Telefone:{' '}
        <ExternalLink href="tel:08005912549">0800 591 2549</ExternalLink>
      </Text>
      <Text size="body3">
        Caso ainda não tenha um ticket de atendimento aberto, fale primeiro com
        nosso time de especialistas pelo{' '}
        <Link href="/contato">Fale Conosco | Flash</Link>.
      </Text>
    </>
  )
}
